import { z } from "zod";
import { assigneeSchema } from "./assignments";
import { tagSchema } from "./tags";
export const companySchema = z.object({
  assignedTo: assigneeSchema.nullable(),
  tags: z.array(tagSchema).optional(),
  id: z.uuid(),
  tenantId: z.uuid(),
  name: z.string(),
  domain: z.string().nullable(),
  url: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
  deletedAt: z.string().nullable(),
  createdBy: z.uuid().nullable(),
  updatedBy: z.uuid().nullable(),
  deletedBy: z.uuid().nullable(),
  peopleCount: z.number(),
});
export const companyDirectorySchema = z.object({
  items: z.array(companySchema),
  total: z.number(),
  page: z.number(),
});
export type Company = z.infer<typeof companySchema>;
